<template>
  <div class="info-box">
    <div class="info-title">
      <el-divider direction="vertical"></el-divider>
      <span>基本信息</span>
    </div>
    <el-row justify="space-between" class="base-info-conent">
      <el-descriptions border>
        <el-descriptions-item label-class-name="pro-user-base-info-item-label" v-for="item in baseItems" :key="item.prop" :label="item.label">
          <template v-if="item.canEdit">
            <template v-if="!item.isEdit">{{user[item.prop]}}</template>
            <el-input v-if="item.canEdit&&item.isEdit&&!item.isSelect" v-model="item.eidtValue" :placeholder="'请输入'+item.label" size="120px"></el-input>
            <el-select v-if="item.isEdit&&item.isSelect" v-model="item.eidtValue" placeholder="请选择">
              <el-option
                v-for="rsl in ralationShipList"
                :key="rsl.id"
                :label="rsl.name"
                :value="rsl.name">
              </el-option>
            </el-select>
            <el-button @click="updateBaseInfo(item)" v-if="!item.isEdit" type="info" plain style="margin-left:3%;">修改</el-button>
            <el-button @click="updateBaseInfoSubmit(item)" v-if="true==item.isEdit" type="info" plain style="margin-left:3%;">提交</el-button>
            <el-button @click="updateBaseInfoCancel(item)" v-if="true==item.isEdit" type="info" plain style="margin-left:3%;">取消</el-button>
          </template>
          <template v-else>
            {{user[item.prop]}}
          </template>
        </el-descriptions-item>
      </el-descriptions>
      <el-avatar :size="180" shape="square" :src="getFileUrl(user.photoPath)"></el-avatar>
    </el-row>

    <div class="info-title">
      <el-divider direction="vertical"></el-divider>
      <span>实名信息</span>
    </div>
    <el-descriptions border>
      <el-descriptions-item label-class-name="pro-user-base-info-item-label" label="身份证照：" label-align="right">
        <el-image v-for="(path, index) in idCardPaths" :key="index" :src="getFileUrl(path)" :preview-src-list="[getFileUrl(path)]"
          class="id-card-path">
        </el-image>
      </el-descriptions-item>
    </el-descriptions>
    
    <div class="info-title">
      <el-divider direction="vertical"></el-divider>
      <span>项目信息</span>
    </div>
    <el-descriptions border>
      <el-descriptions-item label-class-name="pro-user-base-info-item-label" label="所在项目：" span="3">{{getInPro()}}</el-descriptions-item>
      <el-descriptions-item label-class-name="pro-user-base-info-item-label" label="状态：">{{user.workersStatus}}</el-descriptions-item>
      <el-descriptions-item label-class-name="pro-user-base-info-item-label" label="入群时间：">{{user.entryTimeString}}</el-descriptions-item>
    </el-descriptions>
    <el-timeline>
      <el-timeline-item v-for="(record, index) in workStatusRecords" :key="index" :timestamp="record.opTimeString"
        :color="record.opTypeName == '离场' ? '#E6A23C' : '#67C23A'">
        {{ record.opTypeName }}
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { getFileUrl } from '@/utils/common';
import { ElMessage } from "element-plus";
import { getProUserWorkStatusRecordList } from '@/api/proman/prouser';
import { updateBankNO } from "@/api/sys/user";
import { getRalationShipItems } from "@/api/sys/item";

export default defineComponent({
  props: {
    user: Object
  },
  data() {
    return {
      getFileUrl,
      workStatusRecords: [], // 工作状态纪录
      baseItems: [
        { prop: 'name', label: '姓名：' },
        { prop: 'phone', label: '手机号：' },
        { prop: 'marriageStatus', label: '婚姻状况：' },
        { prop: 'idCardNo', label: '身份证号：' },
        // { prop: '', label: '出生日期' },
        { prop: 'sex', label: '年龄：' },
        { prop: 'age', label: '性别：' },
        { prop: 'bankName', label: '工资卡银行：' , canEdit: true, isEdit: false ,eidtValue:null },
        { prop: 'bankCardNo', label: '银行卡号：' , canEdit: true, isEdit: false ,eidtValue:null},
        { prop: 'emergencyContactName', label: '紧急联系人：', canEdit: true, isEdit: false ,eidtValue:null},
        { prop: 'emergencyContactTypeName', label: '与本人关系：' , canEdit: true, isEdit: false,isSelect:true ,eidtValue:null},
        { prop: 'emergencyContactPhone', label: '紧急联系人电话：' , canEdit: true, isEdit: false ,eidtValue:null},
        // { prop: '户籍地址', label: '户籍地址' }
      ],
      proItems: [
        { prop: '', label: '所在项目：' },
        { prop: '', label: '状态：' },
        { prop: '', label: '入群时间：' }
      ],
      updateBaseProp:"",
      updateBaseValue:"",
      updateBaseLabel:"",
      isUpdate:false,
      ralationShipList:[],
    }
  },
  computed: {
    idCardPaths() { // 身份证照地址路径数组
      let ret = [];
      if (this.user && this.user.idCardPath && this.user.idCardPath.length) {
        this.user.idCardPath.split(',').forEach(path => ret.push(path));
      }
      return ret;
    }
  },
  mounted() {
    this.getStatusRecords();
    this.getRalationShipList();
  },
  methods: {
    getInPro() {
      let user = this.user;
      let ret = user.projectName;
      if (user.isProject !== 1) {
        ret += ' - ' + user.teamName;
      }
      if (user.isGroup === 1) {
        ret += ' - ' + user.groupName;
      }
      return ret;
    },
    getStatusRecords() {
      getProUserWorkStatusRecordList(this.user.id).then(({data}) => {
        this.workStatusRecords = data.data;
      }).catch(_ => {})
    },
    updateBaseInfo(item){//console.log(this.user);
      item.eidtValue=this.user[item.prop];
      item.isEdit=!item.isEdit;
    },
    updateBaseInfoSubmit(item){
      if(item.eidtValue==this.user[item.prop]){
        ElMessage({
          message: "值没有变化！",
          type: "Error",
        });
        return;
      }else if(!item.eidtValue){
        ElMessage({
          message: "不能为空！",
          type: "Error",
        });
        return;
      }else if(('emergencyContactPhone'==item.prop||'bankCardNo'==item.prop)&&!/^\d+(\.\d+)?$/.test(item.eidtValue)){
        ElMessage({
          message: "必须为数字！",
          type: "Error",
        });
        return;
      }else if('emergencyContactPhone'==item.prop&&item.eidtValue.length>11){
        ElMessage({
          message: "电话号码不能大于11位！",
          type: "Error",
        });
        return;
      }
      let user={id:this.user.userId},that=this;
      user[item.prop]=item.eidtValue;//console.log(user);
      updateBankNO(user).then(({ data }) => {//console.log(data);
        if (data && data.status === true) {
          ElMessage({
            message: "保存成功",
            type: "success",
          });
          item.isEdit= false;
          that.user[item.prop]=item.eidtValue;
        } else {
          ElMessage({
            message: data.msg,
            type: "Error",
          });
        }
      });
    },
    getRalationShipList(){
      getRalationShipItems().then(({data}) => {//console.log(data);
        this.ralationShipList = data.data;
      })
    },
    updateBaseInfoCancel(item){
      item.isEdit=!item.isEdit;
      this.updateBaseValue=null;
    }
  }
})
</script>

<style lang="scss" scoped>
.info-box {
  margin-top: 25px;
  .info-title {
    .el-divider {
      background-color: #02a7f0;
      width: 4px;
      height: 30px;
    }
  }
  .el-descriptions {
    padding: 15px;
    .id-card-path {
      width: 250px;
      height: 150px;
    }
    .id-card-path + .id-card-path {
      margin-left: 25px;
    }
  }
  .base-info-conent {
    .el-descriptions {
      flex-grow: 1;
    }
  }
}
</style>

<style lang="scss">
.pro-user-base-info-item-label {
  width: 140px;
}
</style>